import { render } from "./SalesListsDetailsLayout.vue?vue&type=template&id=d0d25538&scoped=true"
import script from "./SalesListsDetailsLayout.vue?vue&type=script&lang=js"
export * from "./SalesListsDetailsLayout.vue?vue&type=script&lang=js"

import "./SalesListsDetailsLayout.vue?vue&type=style&index=0&id=d0d25538&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0d25538"]])

export default __exports__